import { render, staticRenderFns } from "./ColorSetsLibrary.vue?vue&type=template&id=22172c24&scoped=true&"
import script from "./ColorSetsLibrary.vue?vue&type=script&lang=js&"
export * from "./ColorSetsLibrary.vue?vue&type=script&lang=js&"
import style0 from "./ColorSetsLibrary.vue?vue&type=style&index=0&id=22172c24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22172c24",
  null
  
)

export default component.exports